import { cloneElement} from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { useFormFieldArray } from './context';

import type { FC,DetailedReactHTMLElement } from 'react';
import type { ControllerProps } from 'react-hook-form';

export interface FieldArrayControlProps {
  children: DetailedReactHTMLElement<ControllerProps & {index: number}, HTMLElement>,
  // children: React.ReactElement<
  //   { index: number } & Parameters<ControllerProps['render']>[0]
  // >;
  name: ControllerProps['name'];
  index: number;
}

export const FieldArrayControl: FC<FieldArrayControlProps> = ({
  children,
  name,
  index,
}) => {
  const { control } = useFormContext();
  const { name: arrayName } = useFormFieldArray();
  return (
    <Controller
      name={`${arrayName}.${index}.${name}`}
      control={control}
      render={typeof children === 'function'
        ? children
        : (props) =>
          cloneElement<ControllerProps & { index: number}>( children, {
            index,
            ...props,
          } )}
    />
  );
};
